import I18n from 'I18n';
export let HubSpotProduct;
(function (HubSpotProduct) {
  HubSpotProduct["SALES_HUB"] = "SALES_HUB";
  HubSpotProduct["SERVICE_HUB"] = "SERVICE_HUB";
  HubSpotProduct["OPS_HUB"] = "OPS_HUB";
  HubSpotProduct["MARKETING_HUB"] = "MARKETING_HUB";
  HubSpotProduct["CMS_HUB"] = "CMS_HUB";
  HubSpotProduct["CONTENT_HUB"] = "CONTENT_HUB";
  HubSpotProduct["COMMERCE_HUB"] = "COMMERCE_HUB";
})(HubSpotProduct || (HubSpotProduct = {}));
export const getProductList = () => [{
  text: I18n.text('profilePage.editProfile.productsUsed.hubspotProducts.SALES_HUB'),
  value: HubSpotProduct.SALES_HUB
}, {
  text: I18n.text('profilePage.editProfile.productsUsed.hubspotProducts.CMS_HUB'),
  value: HubSpotProduct.CMS_HUB
}, {
  text: I18n.text('profilePage.editProfile.productsUsed.hubspotProducts.CONTENT_HUB'),
  value: HubSpotProduct.CONTENT_HUB
}, {
  text: I18n.text('profilePage.editProfile.productsUsed.hubspotProducts.MARKETING_HUB'),
  value: HubSpotProduct.MARKETING_HUB
}, {
  text: I18n.text('profilePage.editProfile.productsUsed.hubspotProducts.OPS_HUB'),
  value: HubSpotProduct.OPS_HUB
}, {
  text: I18n.text('profilePage.editProfile.productsUsed.hubspotProducts.SERVICE_HUB'),
  value: HubSpotProduct.SERVICE_HUB
}];